import React from 'react';

const Python = () => {
  return (
    <div className="content-page">
      <h1>Python Tutorial</h1>
      
      <div className="tutorial-section">
        <h2>What is Python?</h2>
        <p>Python is a popular programming language. It was created by Guido van Rossum, and released in 1991. It is used for web development, software development, mathematics, system scripting, and more.</p>
      </div>

      <div className="example">
        <h3>Example</h3>
        <div className="code-container">
          <pre>{`# This is a comment
print("Hello, World!")

# Variables and data types
x = 5
name = "John"
price = 19.95
is_active = True

# Lists
fruits = ["apple", "banana", "cherry"]
for fruit in fruits:
    print(fruit)

# Functions
def greet(name):
    return f"Hello, {name}!"

print(greet("Alice"))`}</pre>
          <button className="try-it-btn">Try it Yourself »</button>
        </div>
      </div>

      <div className="tutorial-navigation">
        <button className="btn-prev">❮ Previous</button>
        <button className="btn-next">Next ❯</button>
      </div>
    </div>
  );
};

export default Python;
